export const ALL_USERS_ROLE = "-All Users-";
export const REQUEST_TYPE_LABEL = "Request Type";

export const REQUEST_TYPES = {
  BOTH: "Both",
  LIGHTS_OUT: "LightsOut",
  LIGHTS_ON: "LightsOn",
  DOCUMENT_REQUEST: "DocumentRequest",
  DOCUMENT_REQUEST_IMPORT: "DocumentRequestImport",
};

export const CONFIGURATION = {
  PACKAGE: "Package",
  DELIVERY_TYPE: "Delivery Type",
  GENERIC_CONTROL: "Generic Control"
};

export const EPC_REQUEST_TYPES = {
  DISCLOSURES: "Disclosures",
  CLOSING: "Closing_Package",
  PROCESSING: "Processing",
}

export const DELIVERY_PREFIX = {
  EDISCLOSE: "edisclose",
  ESIGN: "esign",
  ECLOSE: "eclose",
  RON: "ron",
  ENOTE: "enote",
  IPEN: "ipen"
}

export const SECONDARY_CAPTIONS = {
  ESign: "eSign - Secondary",
  EDisclose: "eDisclose - Secondary",
  EClose: "eClose - Secondary"
};

// Tree-only labels for unnamed dynamic secondary rows (not persisted to Caption).
export const ADDITIONAL_SECONDARY_PLACEHOLDERS: Record<string, string> = {
  eSign: "[Additional eSign]",
  eDisclose: "[Additional eDisclose]",
  eClose: "[Additional eClose]"
};

export const SCOPE_TYPE = {
  LOAN: "LOAN",
  APPLICATION: "APPLICATION",
}

export const SAVE_LOAN_OPTIONS = [
  { value: "Always", label: "Always" },
  { value: "WhenRecalculationsAreNotComplete", label: "When Recalculations Pending" },
  { value: "Never", label: "Never" }
];

export const REQUEST_TYPE_OPTIONS = [
  { value: "LightsOut", label: "Lights Out" },
  { value: "LightsOn", label: "Lights On" },
  { value: "Both", label: "Both" }
];

export const DEFAULT_REQUEST_OPTIONS = [
  { value: "LightsOut", label: "Lights Out" },
  { value: "LightsOn", label: "Lights On" }
];

export const PREVIEW_ATTACHMENTS_OPTIONS = [
  { value: "true", label: "True" },
  { value: "false", label: "False" }
];

export const PANEL_IDS = {

  ATTACHMENTS:"pnlAttachments",
  SELECT_TO_PRINT:"pnlSelectToPrint",
  REQUEST_TYPE:"pnlRequestType",
  LOGS_TAB: "tbLogs",
  REQUEST_RESPONSE_TAB: "tbReqResp",
  CONFIGURATION: "lnkConfigProxyControl"
}

export const EPC_ACTIONS = {
  GET_RESOURCES: "getAvailableResources",
  GET_ROLES: "getRoles"
}

export const EMAIL_REGEX = /^\S+@\S+\.\S+$/;

export const API_REQUEST_STATUS = {
  PENDING: 1,
  COMPLETE: 2,
  ERROR: 3
}

export const PRESIGN_API_OBJECTS = {
  METADATA: "metadata.zip",
  DOCUMENTS: "generated_documents.zip",
  PDF_PACKAGE:"package.pdf"
}

export const BUTTON_LABELS = {
  SEND: "Send",
  PREVIEW: "Preview",
}

export const PackageTypeUnassigned = "Unassigned";

export const CX_Docutech_Selected_Package = "CX.DOCUTECH.SELECTED.PACKAGE";
export const CX_Docutech_Delivery_Types = "CX.DOCUTECH.DELIVERYTYPES";

export const ValidDeliveryTypes = "ValidDeliveryTypes";
export const AutoSelectWhen = "AutoSelectWhen";

// Warning display duration - how long (in seconds) the warning modal stays open before auto-logout
export const WARNING_MODAL_DURATION_SECONDS = 30;

// Inactivity warning - show modal after this many seconds of user inactivity
// Backend sends ExpirationDateTimeUTC = actual_token_expiry - 30s (CacheBufferSeconds)
// For a 15-minute (900s) token, backend sends 870s as the adjusted expiration
// We show the modal BEFORE that, leaving time for the modal countdown:
// 870s (adjusted expiration) - 30s (modal duration) = 840s (14 minutes)
export const INACTIVITY_WARNING_SECONDS = 840;
